/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 * Full interview snapshot for the detail dialog (Summary / Tasks / Transcript).
 * @export
 * @interface InterviewDetail
 */
export interface InterviewDetail {
  /**
   *
   * @type {string}
   * @memberof InterviewDetail
   */
  applicationInterviewId: string;
  /**
   *
   * @type {string}
   * @memberof InterviewDetail
   */
  title?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof InterviewDetail
   */
  meetingDate?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof InterviewDetail
   */
  jamieUrl?: string | null;
  /**
   *
   * @type {string}
   * @memberof InterviewDetail
   */
  summaryMarkdown?: string | null;
  /**
   *
   * @type {string}
   * @memberof InterviewDetail
   */
  transcript?: string | null;
  /**
   *
   * @type {string}
   * @memberof InterviewDetail
   */
  notes?: string | null;
  /**
   *
   * @type {string}
   * @memberof InterviewDetail
   */
  participantsJson?: string | null;
  /**
   *
   * @type {string}
   * @memberof InterviewDetail
   */
  actionItemsJson?: string | null;
  /**
   *
   * @type {string}
   * @memberof InterviewDetail
   */
  createdBy?: string | null;
}

/**
 * Check if a given object implements the InterviewDetail interface.
 */
export function instanceOfInterviewDetail(
  value: object,
): value is InterviewDetail {
  if (
    !("applicationInterviewId" in value) ||
    value["applicationInterviewId"] === undefined
  )
    return false;
  return true;
}

export function InterviewDetailFromJSON(json: any): InterviewDetail {
  return InterviewDetailFromJSONTyped(json, false);
}

export function InterviewDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InterviewDetail {
  if (json == null) {
    return json;
  }
  return {
    applicationInterviewId: json["applicationInterviewId"],
    title: json["title"] == null ? undefined : json["title"],
    meetingDate: json["meetingDate"] == null ? undefined : json["meetingDate"],
    jamieUrl: json["jamieUrl"] == null ? undefined : json["jamieUrl"],
    summaryMarkdown:
      json["summaryMarkdown"] == null ? undefined : json["summaryMarkdown"],
    transcript: json["transcript"] == null ? undefined : json["transcript"],
    notes: json["notes"] == null ? undefined : json["notes"],
    participantsJson:
      json["participantsJson"] == null ? undefined : json["participantsJson"],
    actionItemsJson:
      json["actionItemsJson"] == null ? undefined : json["actionItemsJson"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
  };
}

export function InterviewDetailToJSON(json: any): InterviewDetail {
  return InterviewDetailToJSONTyped(json, false);
}

export function InterviewDetailToJSONTyped(
  value?: InterviewDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    applicationInterviewId: value["applicationInterviewId"],
    title: value["title"],
    meetingDate: value["meetingDate"],
    jamieUrl: value["jamieUrl"],
    summaryMarkdown: value["summaryMarkdown"],
    transcript: value["transcript"],
    notes: value["notes"],
    participantsJson: value["participantsJson"],
    actionItemsJson: value["actionItemsJson"],
    createdBy: value["createdBy"],
  };
}
